<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/gardiennage-chantier.png'" [alt]="'gardiennage-chantier'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Gardiennage <br>chantier</h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>La surveillance de chantiers réalisée par Farco Security offre une <br> protection lors de chaque étape du projet de construction...</h2>
                <h3>Nous planifions une sécurité adapté et sur mesure à chaque étapes du chantier.</h3>
                <p>Nous offrons une surveillance ponctuelle et permanente pour vous permettre d’éviter les vols et dommages pour éviter toute perte ou retard inutile. En agissant d’une manière préventive, votre entreprise diminuera fortement les risques
                    et vols internes ainsi que toutes formes de fraudes quelconques.<br> Les vols importants de cuivre, d’engins de chantier, de marchandises, … ont des conséquences importantes sur l’évolution du chantier, c’est pourquoi il est important
                    de prévoir un gardiennage statique dès l’élaboration du projet.

                </p>
                <p class="mt-5 mb-2">Nos services :</p>
                <ul class="mb-2">
                    <li>Contrôle des autorisations d’accès au chantier en véhicule ou à pied</li>
                    <li>Surveillance des rotations de matériel afin de prévenir les vols internes</li>
                    <li>Surveillance des consignes sécurité</li>
                    <li>Contrôle des badges</li>
                    <li>Évacuation d’urgence</li>
                    <li>Réception de livraisons en dehors des heures</li>
                </ul>
            </div>
        </div>
    </div>
</section>